import React, { useState } from "react";
import DisplayList from "../common/DisplayList";
import DeleteDialog from "../common/DeleteDialog";
import TagInput from "../TagInput/TagInput";

function TagRange({ tagNumbers, handleChange, handleDelete }) {
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(false);
  const [idxNumber, setIdxNumber] = useState(null);

  const _handleClick = (event, idx) => {
    event.preventDefault();
    setIdxNumber(idx);
    setOpen(!open);
  };

  const _handleDelete = (idx) => {
    setOpen(!open);
    handleDelete(idx);
  };

  return (
    <>
      <DisplayList
        title="Tag Number / Tag Range"
        type="tagRange"
        data={tagNumbers}
        handleDialog={setDisplay}
        handleClick={_handleClick}
      />
      {open && (
        <DeleteDialog
          isVisible={open}
          element="Tag Range"
          setIsVisible={setOpen}
          itemIdx={idxNumber}
          deleteAction={_handleDelete}
        />
      )}
      {display && (
        <TagInput
          isVisible={display}
          setVisible={setDisplay}
          confirmValues={handleChange}
        />
      )}
    </>
  );
}

export default TagRange;
